import { parse } from 'date-fns';

export const parseTime = (time: string): ReturnType<typeof parse> => {
  const formats = [
    'HH:mm',
    'HH:mm:ss',
    'HH:mm:ss.S',
    'HH:mm:ss.SS',
    'HH:mm:ss.SSS',
    'HH:mm:ss.SSSS',
    'HH:mm:ss.SSSS',
    'HH:mm:ss.SSSSS',
    'HH:mm:ss.SSSSSS',
  ];
  let result: ReturnType<typeof parse> | null = null;
  formats.some((format, i) => {
    try {
      result = parse(time, format, new Date());
      if (isNaN(result.getTime())) {
        throw new Error('Could not parse time');
      }
      return true;
    } catch (err) {
      if (i == formats.length - 1) {
        throw err;
      }
    }
  });

  if (!result) {
    throw new Error('Could not parse time');
  }
  return result;
};
